<template>
  <div class="definition-controls">
    <button
      @click="groupAttributes"
      :disabled="groupDisable || isDragAndDropActive"
      title="Group (g)"
    >
      <svg-icon
        id="definition-controls__group"
        :icon="group"
        :width="18"
        :height="18"
      ></svg-icon>
    </button>
    <button
      @click="ungroupAttributes"
      :disabled="ungroupDisable || isDragAndDropActive"
      title="Ungroup (u)"
    >
      <svg-icon
        id="definition-controls__ungroup"
        :icon="ungroup"
        :width="18"
        :height="18"
      ></svg-icon>
    </button>
    <button
      @click="countGroupHandler"
      :disabled="countGroupDisable || isDragAndDropActive"
    >
      <svg-icon
        :icon="countGroupIcon"
        :width="18"
        :height="18"
      ></svg-icon>
    </button>
    <button
      title="Drag and drop mode"
      :class="{ active: isDragAndDropActive }"
      @click="dragAndDropModeToggle"
    >
      <svg-icon
        id="definition-controls__arrows"
        :icon="arrows"
      ></svg-icon>
    </button>
    <button
      @click="deleteAttributes"
      :disabled="deleteDisable || isDragAndDropActive"
      title="Delete (Delete/Backspace)"
    >
      <svg-icon
        id="definition-controls__trash"
        :icon="trash"
        :width="15"
        :height="18"
      ></svg-icon>
    </button>
  </div>
</template>

<script>
  import group from '@/assets/svg/group.svg'
  import ungroup from '@/assets/svg/ungroup.svg'
  import trash from '@/assets/svg/trash.svg'
  import arrows from '@/assets/svg/arrows.svg'
  import countGroup from '@/assets/svg/count-group.svg'
  import removeCountGroupIcon from '@/assets/svg/remove-count-group.svg'
  import SvgIcon from '@/components/common/svgIcon'
  import { isCountGroup } from '../store/mutations'
  import { createPopover, popoverTypes } from '@/components/common/popover'
  import {
    GROUP,
    UNGROUP,
    REMOVE_ATTRIBUTE,
    ACTIVATE_DRAG_DROP,
    DEACTIVATE_DRAG_DROP,
    CREATE_COUNT_GROUP,
    REMOVE_COUNT_GROUP,
  } from '@/appComponents/workbench/targetDefinition/store/actions'
  import { RESET_FAMILY_DATASETS } from '@/appLogic/workbench/common/store/actions'
  import { TARGET_TYPE, ACTIVATION_STATUS, DESTINATIONS } from '@/appLogic/targets/Constants'

  export default {
    components: {
      SvgIcon,
    },
    data() {
      return {
        group,
        ungroup,
        trash,
        arrows,
        countGroup,
        removeCountGroupIcon,
      }
    },
    computed: {
      groupDisable() {
        return !this.$store.getters['workbench/selectedCanBeGrouped']
      },
      ungroupDisable() {
        return !this.$store.getters['workbench/selectedCanBeUngrouped']
      },
      deleteDisable() {
        return !this.$store.getters['workbench/selectedCanBeDeleted']
      },
      isDragAndDropActive() {
        return this.$store.getters['workbench/isDragAndDropActive']
      },
      countGroupDisable() {
        return (
          !this.$store.getters['workbench/selectedCanBecomeCountGroup'] ||
          (this.$store.getters['workbench/newWorkbenchTarget'] || {}).target === TARGET_TYPE.XANDR_SEGMENT ||
          (this.$store.getters['workbench/newWorkbenchTarget'] || {}).target === TARGET_TYPE.ADSTRA
        )
      },
      isSelectedACountGroup() {
        let selectedAttributes = this.$store.getters['workbench/selectedAttributes']
        if (selectedAttributes) {
          const attribute = selectedAttributes[0]
          if (!attribute) {
            return false
          }
          return isCountGroup(attribute)
        }
      },
      countGroupIcon() {
        return this.isSelectedACountGroup ? removeCountGroupIcon : countGroup
      },
    },
    methods: {
      groupAttributes() {
        this.$store.dispatch('workbench/' + GROUP)
      },
      ungroupAttributes() {
        this.$store.dispatch('workbench/' + UNGROUP)
      },
      deleteAttributes() {
        this.$store.dispatch('workbench/' + REMOVE_ATTRIBUTE)
        this.$store.dispatch('workbench/' + RESET_FAMILY_DATASETS)
      },
      dragAndDropModeToggle() {
        this.isDragAndDropActive
          ? this.$store.dispatch('workbench/' + DEACTIVATE_DRAG_DROP)
          : this.$store.dispatch('workbench/' + ACTIVATE_DRAG_DROP)
      },
      countGroupHandler(e) {
        const attribute = this.$store.getters['workbench/selectedAttributes'][0]
        this.isSelectedACountGroup ? this.removeCountGroup(attribute.definitionId) : this.createCountGroup(e, attribute)
      },
      createCountGroup(e, attribute) {
        // add popover to chose the count for the new group
        // have to get the count group attribute
        this.popover = createPopover({
          direction: 'left',
          attribute: attribute,
          parent: e.target,
          root: document.getElementById('app'),
          type: popoverTypes.COUNT_GROUP,
        })
        this.popover.$on('select', value => {
          const details = {
            groupId: attribute.definitionId,
            mustMatch: value,
          }
          this.$store.dispatch('workbench/' + CREATE_COUNT_GROUP, details)
        })
      },
      removeCountGroup(groupId) {
        this.$store.dispatch('workbench/' + REMOVE_COUNT_GROUP, groupId)
      },
    },
  }
</script>

<style lang="scss">
  #definition-controls {
    &__group {
      width: rem(18) !important;
      height: rem(18) !important;
    }
    &__ungroup {
      width: rem(18) !important;
      height: rem(18) !important;
    }
    &__trash {
      width: rem(15) !important;
      height: rem(18) !important;
    }
    &__arrows {
      width: rem(20) !important;
      height: rem(20) !important;
    }
  }
  .definition-controls {
    display: flex;
    flex-wrap: wrap;
    max-height: 100%;
    width: rem(92px);

    button {
      margin: rem(5) rem(2.5) 0;
      width: rem(40);
      height: rem(40);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: rem(4);
      background: black;
      border: none;

      svg {
        margin: auto;
        fill: white;
      }

      &:focus {
        outline: none;
      }

      &:hover,
      &.active {
        svg {
          fill: color(yellow);
        }
      }
      &:disabled {
        opacity: 0.3;

        &:hover {
          cursor: not-allowed;
          svg {
            fill: white;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// DefinitionControls.vue?1a87649e